// extracted by mini-css-extract-plugin
export default {"editButton":"styles_editButton__zZPCA","deleteButton":"styles_deleteButton__Vfbu6","deactivateButton":"styles_deactivateButton__n3y-4","buttonIcon":"styles_buttonIcon__4RWq3"};